<!--
 * @Author: your name
 * @Date: 2021-07-28 12:06:25
 * @LastEditTime: 2021-07-28 14:16:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JN010665\src\views\user\record.vue
-->
<template>
  <div class="commission-details" ref="container">
    <div class="sign-record" ref="content">
      <div class="list">
        <div class="item">
          <div class="listn" v-for="(val, indexn) in info" :key="indexn">
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name">{{ val.mark }}</div>
                <div>{{ val.add_time }}</div>
              </div>
              <div class="num" v-if="val.pm == 1">+{{ val.num }}</div>
              <div class="num font-color-red" v-if="val.pm == 0">
                -{{ val.num }}
              </div>
            </div>
          </div>
          <div class="nolist" v-if="info.length == 0">暂无数据</div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { transList } from "../../api/user";
import Loading from "@components/Loading";

export default {
  name: "CommissionDetails",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      info: [],
      commission: 0,
      where: {
        type: "brokerage_price",
        page: 1,
        limit: 15
      },
      types: 3,
      loaded: false,
      loading: false
    };
  },
  mounted: function() {
    if (this.$route.query.type) {
      this.where.type = this.$route.query.type || "now_money";
    }
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      transList(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data);
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.nolist {
  text-align: center;
  line-height: 10vw;
  color: #666;
}
</style>
